import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  watchProvidersModal: boolean;
};

const initialState: InitialState = {
  watchProvidersModal: false,
};

const watchProvidersModalSlice = createSlice({
  name: "watchProvidersModalSlice",
  initialState,
  reducers: {
    toggleWatchProvidersModal: (state, action: PayloadAction) => {
      state.watchProvidersModal = !state.watchProvidersModal;
      return state;
    },
  },
});

export const { toggleWatchProvidersModal } = watchProvidersModalSlice.actions;
export default watchProvidersModalSlice;
